import { useState, useCallback } from 'react';

// IMP-107 (AC-3): 확인 모달 show/hide + confirm 핸들러.
// VoucherTemplateEditor 의 reset confirm 에서 분리 — 다른 모달에서도 재사용 가능한 범용 훅.
//
// onConfirm: confirm() 시 실행할 비동기/동기 콜백. confirm 은 먼저 모달을 닫고 콜백을 실행한다.
export const useResetConfirmModal = (onConfirm) => {
    const [show, setShow] = useState(false);

    const open = useCallback(() => setShow(true), []);
    const close = useCallback(() => setShow(false), []);
    const confirm = useCallback(async () => {
        setShow(false);
        if (typeof onConfirm === 'function') {
            await onConfirm();
        }
    }, [onConfirm]);

    return { show, open, close, confirm };
};

export default useResetConfirmModal;
